import upperFirst from 'lodash/upperFirst';
const reducer = (acc, part) => acc.concat(upperFirst(part));
export default ((str, isPascalCase) => {
  const parts = str.split(/[-|\s]+/g);
  return isPascalCase ? parts.reduce(reducer, '') : parts.reduce(reducer);
});